import { FC } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Card } from 'lib/components';

export const SelectPlanCard: FC = ({ children }) => (
  <Card className="lg:bg-getting-started bg-auto-100 bg-no-repeat bg-right-top lg:bg-[length:auto_100%] mb-[104px] md:mb-[88px] !overflow-visible relative">
    {children}

    <StaticImage
      className="!absolute !hidden lg:!block right-[-80px] top-1/2 -translate-y-1/2 max-w-[320px]"
      src="../../../images/chicken-skewer-dish.png"
      alt="A delicious plate of carrots, cucumbers, jalapeños, and shrimp."
      placeholder="blurred"
    />
  </Card>
);
